import type { Dayjs } from 'dayjs';
import type { CreatePatientPayload, PatientSex } from '@/models/patient';

export interface NewPatientFormValues {
  firstName: string;
  lastName: string;
  medicalRecordNumber: string;
  dateOfBirth: Dayjs;
  sex?: PatientSex;
  referringPhysicianFirstName?: string;
  referringPhysicianLastName?: string;
  phoneNumber?: string;
  address?: string;
  ethnicity?: string;
  notes?: string;
}

const trimOptional = (v: string | undefined): string | undefined => {
  const t = v?.trim();
  return t || undefined;
};

/**
 * Build the BE request body from the form values. The BE
 * `PatientCreateSerializer` only knows the single field
 * `referringPhysician` (which it splits on whitespace into first/last after
 * stripping a leading honorific). The form has split first/last inputs for
 * UX, so we combine here.
 */
export function buildCreatePatientPayload(
  values: NewPatientFormValues
): CreatePatientPayload {
  const referringFirst = values.referringPhysicianFirstName?.trim() ?? '';
  const referringLast = values.referringPhysicianLastName?.trim() ?? '';
  const referringPhysician =
    `${referringFirst} ${referringLast}`.trim() || undefined;

  return {
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    medicalRecordNumber: values.medicalRecordNumber.trim(),
    dateOfBirth: values.dateOfBirth.format('YYYY-MM-DD'),
    sex: values.sex,
    referringPhysician,
    phoneNumber: trimOptional(values.phoneNumber),
    address: trimOptional(values.address),
    ethnicity: trimOptional(values.ethnicity),
    notes: trimOptional(values.notes),
  };
}
